import React from "react";
import styles from "./pearlDoser.module.css";
import { cl,globs } from "../../../components/utils/utils";

function makeKey(zoneInd, channelInd) {
  return `${zoneInd}-${channelInd}`;
}

function displayChannelName(name) {
  return name === "" ? "No Name" : name;
}

function displayZoneName(name) {
  return name || "No Name";
}

function sortSelKeys(keys) {
  return [...keys].sort((a, b) => {
    const [az, ac] = a.split("-").map(Number);
    const [bz, bc] = b.split("-").map(Number);
    if (az !== bz) return az - bz;
    return ac - bc;
  });
}

function buildGroupedZones(zoneNames, channelNames) {
  const zones = [];
  for (let zoneInd = 0; zoneInd < zoneNames.length; zoneInd++) {
    if (zoneNames[zoneInd] == null) continue;
    const channelArr = channelNames[zoneInd];
    if (channelArr == null) continue;
    const channels = [];
    for (let channelInd = 0; channelInd < channelArr.length; channelInd++) {
      if (channelArr[channelInd] == null) continue;
      channels.push({
        channelInd,
        key: makeKey(zoneInd, channelInd),
        channelName: channelArr[channelInd],
      });
    }
    if (channels.length === 0) continue;
    zones.push({
      zoneInd,
      zoneName: zoneNames[zoneInd],
      channels,
    });
  }
  return zones;
}

function visibleKeySet(groupedZones) {
  const visible = new Set();
  groupedZones.forEach((zone) => {
    zone.channels.forEach((ch) => visible.add(ch.key));
  });
  return visible;
}

function emitSelKeys(selSet, groupedZones, onChange) {
  if (!onChange) return;
  const visible = visibleKeySet(groupedZones);
  const val = sortSelKeys([...selSet].filter((key) => visible.has(key)));
  onChange({ type: "selKeys", val });
}

const truncateCell = {
  maxWidth: "32ch",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const cellPad = { padding: "6px 8px" };
const channelCellPad = { padding: "6px 8px 6px 16px" };

const zoneRowStyle = {
  backgroundColor: "#e8e8e8",
  fontWeight: "bold",
};

export default function DoserValves({ zoneNames, channelNames, selKeys, onChange }) {
  const selSet = new Set(selKeys);
  const groupedZones = buildGroupedZones(zoneNames || [], channelNames || []);
  cl({ zoneNames, channelNames, selKeys, onChange })

  const handleChannelCheck = (key, checked) => {
    const next = new Set(selSet);
    if (checked) {
      next.add(key);
    } else {
      next.delete(key);
    }
    emitSelKeys(next, groupedZones, onChange);
  };

  const handleZoneCheck = (zone) => {
    const zoneKeys = zone.channels.map((ch) => ch.key);
    const allSelected = zoneKeys.every((key) => selSet.has(key));
    const next = new Set(selSet);
    if (allSelected) {
      zoneKeys.forEach((key) => next.delete(key));
    } else {
      zoneKeys.forEach((key) => next.add(key));
    }
    emitSelKeys(next, groupedZones, onChange);
  };

  let channelRowIndex = 0;

  return (
    <div
      style={{
        fontFamily: "system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
        padding: 8,
      }}
    >
      <h3 style={{ margin: "0 0 8px 0" }}>Valves on Doser</h3>
      <div
        className={styles.borderDiv}
        style={{ maxHeight: 674, overflowY: "auto", width: "fit-content" }}
      >
        <table
          style={{
            width: "max-content",
            borderCollapse: "collapse",
            fontSize: 14,
          }}
        >
          <thead>
            <tr style={{ fontWeight: "bold", borderBottom: "1px solid #ccc" }}>
              <th style={cellPad} />
              <th style={cellPad}>Ch</th>
              <th style={{ ...cellPad, ...truncateCell }}>Channel Name</th>
            </tr>
          </thead>
          <tbody>
            {groupedZones.map((zone) => {
              const zoneKeys = zone.channels.map((ch) => ch.key);
              const zoneAllSelected =
                zoneKeys.length > 0 && zoneKeys.every((key) => selSet.has(key));

              const zoneHeader = (
                <tr key={`zone-${zone.zoneInd}`} style={zoneRowStyle}>
                  <td style={cellPad}>
                    <input
                      className={styles.wid0}
                      type="checkbox"
                      checked={zoneAllSelected}
                      onChange={() => handleZoneCheck(zone)}
                    />
                  </td>
                  <td colSpan={3} style={cellPad}>
                    {displayZoneName(zone.zoneName)} Channels
                  </td>
                </tr>
              );

              const channelRows = zone.channels.map((ch) => {
                const stripeIdx = channelRowIndex++;
                return (
                  <tr
                    key={ch.key}
                    style={{
                      backgroundColor: stripeIdx % 2 === 1 ? "#fafafa" : "#fff",
                    }}
                  >
                    <td style={channelCellPad}>
                      <input
                        className={styles.wid0}
                        type="checkbox"
                        checked={selSet.has(ch.key)}
                        onChange={(e) =>
                          handleChannelCheck(ch.key, e.target.checked)
                        }
                      />
                    </td>
                    <td style={channelCellPad}>{ch.channelInd + 1}</td>
                    <td
                      style={{ ...channelCellPad, ...truncateCell }}
                      title={displayChannelName(ch.channelName)}
                    >
                      {displayChannelName(ch.channelName)}
                    </td>
                  </tr>
                );
              });

              return [zoneHeader, ...channelRows];
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
//               <th style={{ ...cellPad, ...truncateCell }}>Zone</th>
//                     <td
//                       style={{ ...channelCellPad, ...truncateCell }}
//                       title={zone.zoneName}
//                     >
//                       {zone.zoneName}
//                     </td>
}
